module.exports = __webpack_public_path__ + "static/media/shield_img.5e2a8dd9.png";